import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { ApplicationUser } from '../models/application-user.model';
import { environment } from '../../../../environments/environment';
import { tap, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  $user = new BehaviorSubject<ApplicationUser>(null);

  constructor(private http: HttpClient) {}

  getAuth(): Observable<ApplicationUser> {
    return this.http
      .get<ApplicationUser>(`${environment.apiUrl}auth/user`, { withCredentials: true })
      .pipe(tap(a => this.$user.next(a)));
  }

  login(loginObj: any) {
    return this.http.post<any>(`${environment.apiUrl}auth/login`, loginObj, { withCredentials: true });
  }

  signOut() {
    return this.http.post<any>(`${environment.apiUrl}auth/logout`, {}, { withCredentials: true });
  }

  forgotPassword(email: string) {
    return this.http.post<any>(`${environment.apiUrl}auth/forgot-password?email=${email}`, null);
  }

  validateToken(token: string, uid: string) {
    return this.http.get<boolean>(`${environment.apiUrl}auth/validate-token?uid=${uid}&token=${token}`);
  }

  resetPassword(token: string, uid: string, passwords: any) {
    return this.http.post<any>(`${environment.apiUrl}auth/reset-password?uid=${uid}&token=${encodeURIComponent(token)}`, passwords);
  }

  inRoles(...roles: string[]) {
    return this.$user.pipe(map(a => (a ? a.roles.some(r => roles.includes(r)) : false)));
  }
}
